import { gql } from '@apollo/client'

//ANTERIOR
export const GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_2 = gql`
  mutation GetAllGroupsCategoriesByGroupIdFormated($group_id: Int!) {
    groupCategories: getAllGroupsCategoriesByGroupIdFormated(
      group_id: $group_id
    ) {
      value
      label
      options {
        label
        value
        id
        group_id
        category_group_name
        category_name
        form_id
      }
    }
  }
`

export const GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT = gql`
  mutation GetAllGroupsCategoriesAndSubsByGroupId(
    $group_id: Int!
    $lat: Float
    $lng: Float
  ) {
    categories: getAllGroupsCategoriesAndSubsByGroupId(
      group_id: $group_id
      lat: $lat
      lng: $lng
    ) {
      id
      group_id
      name
      description
      icon
      subs: GroupsCategoriesSubOfGroupsCategory {
        id
        group_category_id
        name
        description
        icon
        form_id
      }
    }
  }
`

export const GET_ALL_GROUPS_CATEGORIES_BY_GROUP_ID_FORMAT_3 = gql`
  query GetAllGroupsCategoriesAndSubsByGroupIdQuery(
    $groupId: Int
    $form_id: Int
    $getAvailable: Boolean
  ) {
    getAllGroupsCategoriesAndSubsByGroupIdQuery(
      group_id: $groupId
      form_id: $form_id
      getAvailable: $getAvailable
    ) {
      id
      group_id
      name
      description
      icon
      subs: GroupsCategoriesSubOfGroupsCategory {
        id
        group_category_id
        name
        description
        icon
        form_id
      }
    }
  }
`

export const GET_ALL_GROUPS_CATEGORIES_AND_SUBS_BY_CONTEXT = gql`
  query GetAllGroupsCategoriesAndSubsByContext {
    categories: getAllGroupsCategoriesAndSubsByContext {
      id
      group_id
      name
      description
      icon
      subs: GroupsCategoriesSubOfGroupsCategory {
        id
        group_category_id
        name
        description
        icon
        form_id
      }
    }
  }
`

export const GET_ALL_GROUPS_CATEGORIES_BY_IDS = gql`
  query GetAllGroupsCategoriesByIds($ids: [Int!], $flag_group_id: Boolean) {
    categories: getAllGroupsCategoriesByIds(ids: $ids, flag_group_id: $flag_group_id) {
      id
      name
    }
  }
`
